import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { TransitionGroup } from "react-transition-group";
import { useTranslator } from "@templafy/translation";
import { AnimatedNotification } from "./AnimatedNotification.js";
import { actions, useNotificationStore } from "./store.js";
import { MAX_NOTIFICATION_BEFORE_QUEUE } from "./constants.js";
import Notification_module from "./Notification.module.js";
import "./typography/fonts.css";
const NotificationContainer = ()=>{
    const translator = useTranslator();
    const { notifications } = useNotificationStore();
    const [root, setRoot] = useState(document.body);
    useEffect(()=>()=>{
            actions.clear();
        }, []);
    const hiddenNotificationsCount = Math.max(0, notifications.length - MAX_NOTIFICATION_BEFORE_QUEUE);
    const visibleNotifications = notifications.slice(0, MAX_NOTIFICATION_BEFORE_QUEUE);
    useEffect(()=>{
        const mutationObserver = new MutationObserver(()=>{
            setRoot(getTopmostDialog() ?? document.body);
        });
        mutationObserver.observe(document.body, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                'open'
            ]
        });
        return ()=>{
            mutationObserver.disconnect();
        };
    }, []);
    return /*#__PURE__*/ createPortal(/*#__PURE__*/ jsxs("div", {
        onMouseEnter: ()=>useNotificationStore.setState({
                isPaused: true
            }),
        onMouseLeave: ()=>useNotificationStore.setState({
                isPaused: false
            }),
        className: Notification_module.notificationContainer,
        children: [
            /*#__PURE__*/ jsx(TransitionGroup, {
                children: visibleNotifications.map((notification)=>/*#__PURE__*/ jsx(AnimatedNotification, {
                        notification: notification
                    }, notification.id))
            }),
            hiddenNotificationsCount > 0 && /*#__PURE__*/ jsx("div", {
                className: Notification_module.moreMessages,
                "data-testid": "notification-more-messages",
                children: /*#__PURE__*/ jsx("div", {
                    className: Notification_module.cardBody,
                    children: /*#__PURE__*/ jsx("div", {
                        className: Notification_module.moreMessagesTextContainer,
                        children: /*#__PURE__*/ jsx("span", {
                            className: Notification_module.moreMessagesText,
                            children: translator.notificationsMoreMessages({
                                count: hiddenNotificationsCount
                            })
                        })
                    })
                })
            })
        ]
    }), root);
};
const getTopmostDialog = ()=>{
    const dialogs = [
        ...document.getElementsByTagName('dialog')
    ].filter((dialog)=>dialog.open);
    const dialogsWithDepth = dialogs.map((dialog)=>{
        let depth = 0;
        let parentDialog = dialog.parentElement?.closest('dialog');
        while(parentDialog){
            depth += 1;
            parentDialog = parentDialog.parentElement?.closest('dialog');
        }
        return {
            dialog,
            depth
        };
    });
    const sortedDialogs = dialogsWithDepth.sort((a, b)=>a.depth - b.depth);
    return sortedDialogs.at(-1)?.dialog;
};
export { NotificationContainer };
